import { render, staticRenderFns } from "./SettingsMediaUploadVideo.vue?vue&type=template&id=83680cc4&"
import script from "./SettingsMediaUploadVideo.vue?vue&type=script&lang=js&"
export * from "./SettingsMediaUploadVideo.vue?vue&type=script&lang=js&"
import style0 from "./SettingsMediaUploadVideo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports